import * as React from "react";
import { Input, Pagination, Table, Header , Image , Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import _ from 'lodash'



interface InterfaceProps {
  users?: any,
  onDeleteUser:any,
  onActivateUser: any
}
interface InterfaceStates {
  activePage ?: any,
  isLoading ?: any,
  results  ?: any,
  value  ?:any
}

export class UserList extends React.Component<InterfaceProps, InterfaceStates> {
  constructor(props: any) {
    super(props);

    this.state = {
        activePage: 1,
        isLoading: false,
        results: null,
        value: ''
    };
  }

  componentWillMount() {
    this.resetComponent()
  }

  resetComponent = () => {
    this.setState({ isLoading: false, results: null, value: '' })
    }

  handleSearchChange = (e, { value }) => {
    const { users }: any = this.props;
    this.setState({ isLoading: true, value })

    setTimeout(() => {
      if (this.state.value.length < 1) return this.resetComponent()

      const re = new RegExp(_.escapeRegExp(this.state.value))
      const isMatch = result => re.test(result.email)
      this.setState({
        isLoading: false,
        results: _.filter(users, isMatch),
      })
    }, 300)
  }
  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage })
  }

  public render() {
    const { users , onDeleteUser , onActivateUser }: any = this.props;
    const {activePage, value, isLoading, results }: any = this.state;
    const usedList = results ? results : users
    const userKeysArray = Object.keys(usedList)
    return (
      <div>
            <Input 
                style = {{float:"right", marginBottom: "10px"}}
                loading = {isLoading}
                icon='search' 
                value={value}
                onChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                placeholder='Search...' 
                size = "small" />  
            <Table singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Photo</Table.HeaderCell>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>E-mail address</Table.HeaderCell>
                  <Table.HeaderCell>Role</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell>Action</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {users && userKeysArray && userKeysArray.slice((activePage - 1) * 8, (activePage * 8) ).map(key => {
                  return (
                    <Table.Row key={key} >
                      <Table.Cell> 
                        <Header as='h4' image>
                          <Image src={usedList[key].photo} rounded size='small' />
                        </Header>
                      </Table.Cell>
                      <Table.Cell>{usedList[key].name}</Table.Cell>
                      <Table.Cell>{usedList[key].email}</Table.Cell>
                      <Table.Cell>{usedList[key].isAdmin ? "Admin" : "User" }</Table.Cell>
                      <Table.Cell>{usedList[key].deleted ? "Disable" : "Active" }</Table.Cell>
                      <Table.Cell> 
                          {!usedList[key].deleted &&  <Button onClick={() => onDeleteUser({...usedList[key], id: key})} size='small' negative>
                              Delete
                           </Button> }
                          {usedList[key].deleted && <Button onClick={() => onActivateUser({...usedList[key], id: key})} size='small' positive>
                              Activate
                          </Button>}
                          <Button as={Link} to={{ pathname: '/users/'+ key }} size='small' primary>
                              Details
                          </Button>
                      </Table.Cell>
                    </Table.Row>
                  )
                }) }
              </Table.Body>
            </Table>
           { !!userKeysArray && userKeysArray.length > 0 &&
              <div style={{ textAlign:"center"}}>
                <Pagination  
                activePage={activePage}
                onPageChange={(e,{activePage}) => this.handlePaginationChange(e, {activePage})}
                totalPages={userKeysArray.length % 8 === 0 ? userKeysArray.length / 8 : Math.floor(userKeysArray.length / 8) + 1}
                />
              </div> 
            }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pills/users/UserList.tsx